import IconRemove from 'vue-material-design-icons/Delete';
import IconClose from 'vue-material-design-icons/Close';
import IconEdit from 'vue-material-design-icons/Pencil';
import IconSearch from 'vue-material-design-icons/Magnify';
import IconFileCode from 'vue-material-design-icons/FileCodeOutline';
import FormatListChecks from 'vue-material-design-icons/FormatListChecks';
import Printer from 'vue-material-design-icons/Printer';
import EmailOutline from 'vue-material-design-icons/EmailOutline';

export default (actionName, action) => {
  const defaultActions = {
    delete: {
      name: 'delete',
      label: 'Excluir',
      icon: IconRemove,
      action,
    },
    cancel: {
      name: 'cancel',
      label: 'Cancelar',
      icon: IconClose,
      action,
    },
    consult: {
      name: 'consult',
      label: 'Consultar',
      icon: IconSearch,
      action,
    },
    edit: {
      name: 'edit',
      label: 'Editar',
      icon: IconEdit,
      action,
    },
    getXml: {
      name: 'getXml',
      label: 'Gerar XML',
      icon: IconFileCode,
      action,
    },
    confirm: {
      label: 'Confirmar',
      icon: FormatListChecks,
      action,
    },
    getDanfse: {
      name: 'getDanfse',
      label: 'Imprimir DANFSe',
      icon: Printer,
      action,
    },
    sendEmail: {
      name: 'sendEmail',
      label: 'Enviar e-mail',
      icon: EmailOutline,
      action,
    },
  };

  return defaultActions[actionName];
};
